export default __webpack_public_path__ + "static/media/cirec6.cd71ce15.png";